import axios from "axios";
import { base_url } from "../../../utils/baseUrl";
import { config } from "../../../utils/axiosconfig";

const getSettings = async () => {
  const response = await axios.get(`${base_url}cms/settings`);
  return response.data;
};

const updateSettings = async (settingsData) => {
  const response = await axios.put(
    `${base_url}cms/settings`,
    settingsData,
    config
  );
  return response.data;
};

const uploadLogo = async (formData) => {
  const uploadConfig = {
    ...config,
    headers: {
      ...config.headers,
      "Content-Type": "multipart/form-data",
    },
  };
  const response = await axios.put(
    `${base_url}cms/settings/upload/logo`,
    formData,
    uploadConfig
  );
  return response.data;
};

const uploadFavicon = async (formData) => {
  const uploadConfig = {
    ...config,
    headers: {
      ...config.headers,
      "Content-Type": "multipart/form-data",
    },
  };
  const response = await axios.put(
    `${base_url}cms/settings/upload/favicon`,
    formData,
    uploadConfig
  );
  return response.data;
};

const cmsSettingsService = {
  getSettings,
  updateSettings,
  uploadLogo,
  uploadFavicon,
};

export default cmsSettingsService;

